// Incident 2026-10-17 — step-up TOTP: sensitive admin calls answered 428 `step_up_totp_required`
// are replayed once with a fresh, single-use code typed in a masked in-page dialog.
import axios from 'axios';
import i18n from '@/i18n';

const HEADER = 'X-JAPAP-TOTP';

function askTotp(error) {
  const t = (k) => i18n.t(`step_up.${k}`);
  return new Promise((resolve) => {
    const wrap = document.createElement('div');
    wrap.setAttribute('data-testid', 'step-up-totp-dialog');
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(15,5,107,.55);display:flex;align-items:center;justify-content:center';
    wrap.innerHTML = `<form style="background:#fff;border-radius:16px;padding:20px;width:320px;font-family:inherit">
      <div style="font-weight:800;margin-bottom:6px">${t('title')}</div>
      <div style="font-size:12px;color:#475569;margin-bottom:12px">${t('body')}</div>
      <div data-testid="step-up-totp-error" role="alert" style="font-size:12px;color:#B91C1C;margin-bottom:8px;${error ? '' : 'display:none'}">${error ? t(error) : ''}</div>
      <input data-testid="step-up-totp-input" type="password" inputmode="numeric" autocomplete="one-time-code" maxlength="6"
        style="width:100%;padding:10px;border:1px solid #cbd5e1;border-radius:8px;text-align:center;font-size:20px;letter-spacing:6px" />
      <div style="display:flex;gap:8px;margin-top:12px">
        <button type="button" data-testid="step-up-totp-cancel" style="flex:1;padding:8px;border:1px solid #cbd5e1;border-radius:8px;background:#fff">${t('cancel')}</button>
        <button type="submit" data-testid="step-up-totp-submit" style="flex:1;padding:8px;border:0;border-radius:8px;background:#0F056B;color:#fff;font-weight:700">${t('submit')}</button>
      </div></form>`;
    const input = wrap.querySelector('input');
    const done = (v) => { wrap.remove(); resolve(v); };
    const errBox = wrap.querySelector('[data-testid="step-up-totp-error"]');
    wrap.querySelector('form').addEventListener('submit', (e) => {
      e.preventDefault();
      const v = input.value.trim();
      if (!/^\d{6}$/.test(v)) { errBox.textContent = t('format'); errBox.style.display = ''; input.focus(); return; }
      done(v);
    });
    wrap.querySelector('[data-testid="step-up-totp-cancel"]').addEventListener('click', () => done(null));
    wrap.addEventListener('keydown', (e) => { if (e.key === 'Escape') done(null); });
    document.body.appendChild(wrap);
    input.focus();
  });
}

axios.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error?.config || {};
    const d = error?.response?.data?.detail;
    if (error?.response?.status === 428 && d && d.code === 'step_up_totp_required' && !cfg._stepUp) {
      cfg._stepUp = true;
      for (let attempt = 0; attempt < 3; attempt += 1) {
        const code = await askTotp(attempt ? 'invalid' : null);
        if (!code) break;
        cfg.headers = { ...(cfg.headers || {}), [HEADER]: code };
        try {
          return await axios.request(cfg);
        } catch (e) {
          if (!(e?.response?.status === 428 && e?.response?.data?.detail?.code === 'step_up_totp_required')) throw e;
          error = e;
        }
      }
    }
    return Promise.reject(error);
  },
);
